import React from "react";

const ASP_AJAX = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP AJAX</h1>
      <p>This is the ASP AJAX page content.</p>
    </div>
  );
};

export default ASP_AJAX;
